var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoDoc2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 60,
    viewBox: "0 0 48 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9584 0.00262451H1.82108C0.813416 0.00262451 0 0.787745 0 1.76036V58.2422C0 59.2148 0.813416 59.9999 1.82108 59.9999H45.527C46.5346 59.9999 47.3481 59.2148 47.3481 58.2422V15.8222L30.9584 0.00262451Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.527 17.5799H30.9583C29.9507 17.5799 29.1373 16.7948 29.1373 15.8222V1.76036C29.1373 1.04555 29.5865 0.412769 30.2663 0.131533C30.9462 -0.137985 31.7353 0.0143509 32.2452 0.518232L46.8139 14.58C47.3359 15.0839 47.4937 15.8339 47.2145 16.4901C46.9231 17.1463 46.2675 17.5799 45.527 17.5799Z",
    fill: "#0EE8A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3734 24.6276C19.2089 25.4645 19.2089 26.8212 18.3734 27.6581L14.0507 32L18.3734 36.3419C19.2089 37.1788 19.2089 38.5355 18.3734 39.3724C17.538 40.2092 16.1835 40.2092 15.3481 39.3724L8 32L15.3481 24.6276C16.1835 23.7908 17.538 23.7908 18.3734 24.6276Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3734 24.6276C19.2089 25.4645 19.2089 26.8212 18.3734 27.6581L14.0507 32L18.3734 36.3419C19.2089 37.1788 19.2089 38.5355 18.3734 39.3724C17.538 40.2092 16.1835 40.2092 15.3481 39.3724L8 32L15.3481 24.6276C16.1835 23.7908 17.538 23.7908 18.3734 24.6276Z",
    fill: "#0EE8A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6266 39.3724C27.7911 38.5355 27.7911 37.1788 28.6266 36.3419L32.9493 32L28.6266 27.6581C27.7911 26.8212 27.7911 25.4645 28.6266 24.6276C29.462 23.7908 30.8165 23.7908 31.6519 24.6276L39 32L31.6519 39.3724C30.8165 40.2092 29.462 40.2092 28.6266 39.3724Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6266 39.3724C27.7911 38.5355 27.7911 37.1788 28.6266 36.3419L32.9493 32L28.6266 27.6581C27.7911 26.8212 27.7911 25.4645 28.6266 24.6276C29.462 23.7908 30.8165 23.7908 31.6519 24.6276L39 32L31.6519 39.3724C30.8165 40.2092 29.462 40.2092 28.6266 39.3724Z",
    fill: "#0EE8A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.674,
    y1: 0.00262451,
    x2: 23.674,
    y2: 59.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12C891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#078667"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDoc2);
export default __webpack_public_path__ + "static/media/picto_doc_2.379bc9d834ecc4be9d40d1adfa7def1d.svg";
export { ForwardRef as ReactComponent };